import apiClient from "./billingServiceClient";

export const fetchInvoices = async () => {
  const response = await apiClient.get("/invoices");
  return response.data;
};

export default {
  fetchInvoices,
};
